import { eachDayOfInterval, getDay, isSameDay } from "date-fns";

/**
 * 休工日を除いた工程の何日間の何日目かを表すオブジェクト
 */
export class DateIndex {
  constructor(
    private date: Date,
    private workPeriod: { start: Date; end: Date },
    private closedDays: (0 | 1 | 2 | 3 | 4 | 5 | 6)[]
  ) {}

  /**
   * 期間内の営業日のリスト
   */
  private get businessDays(): Date[] {
    return eachDayOfInterval(this.workPeriod).filter(
      d => !this.closedDays.some(cd => getDay(d) === cd)
    );
  }

  /**
   * 何日間か
   */
  get days(): number {
    return this.businessDays.length;
  }

  /**
   * 何日目か
   */
  get day(): number {
    return this.businessDays.findIndex(d => isSameDay(this.date, d)) + 1;
  }

  toString(): string {
    return `${this.day}/${this.days}`;
  }

  isFirstDay(): boolean {
    return this.day === 1;
  }
}
